import { PickingValidateState } from '../../interfaces/Picking/Picking'
import {
  SET_PICKING_ROUTE_ID,
  SET_MESSAGE_COLOR,
  SET_MESSAGE_STATUS,
  SWITCH_MODAL,
  SWITCH_SNACKBAR,
  SET_ROWS_PICKING_VALIDATE,
  SHOW_MODAL_REPORT_DIFF,
  SET_IS_LOADING_GRID,
  SET_BTN_FILTER,
  SET_LOADING_PRINT,
  SET_PICKING_VALIDATE_PDF,
  SET_TOTAL_ITEMS,
  CHANGE_PAGE,
  CHANGE_PAGE_SIZE,
  SET_SKU_ID,
  SET_LOADING_BUTTON,
  SHOW_ALERT
} from './PickingValidateActionTypes'
import {
  SetSkuId,
  PickingRouteIdAction,
  SetMessageStatus,
  SetMessageColor,
  SetSwitchSnackbar,
  SetSwitchModal,
  SetRowsPickingValidate,
  ShowModalReportDiff,
  SetIsLoadingGrid,
  SetBtnFilter,
  SetLoadingPrint,
  SetPickingValidatePDF,
  SetTotalItems,
  ChangePage,
  ChangePageSize,
  SetLoadingButton,
  ShowAlert
} from './PickingValidateAction'

export const reducerInitialState: PickingValidateState = {
  skuId: '',
  pickingRouteId: 0,
  mensaje: '',
  tipoMensaje: '',
  switchSnackBar: false,
  switchModal: false,
  rows: undefined,
  showModalReportDiff: false,
  isLoadingGrid: false,
  btnFilter: '',
  isLoadingPrint: false,
  pickingValidatePDF: '',
  page: 0,
  rowsPerPage: 5,
  totalItems: 0,
  isLoadingButton: false,
  showAlert: false
}

type Action =
  | SetSkuId
  | PickingRouteIdAction
  | SetMessageStatus
  | SetMessageColor
  | SetSwitchSnackbar
  | SetSwitchModal
  | SetRowsPickingValidate
  | ShowModalReportDiff
  | SetIsLoadingGrid
  | SetBtnFilter
  | SetLoadingPrint
  | SetPickingValidatePDF
  | SetTotalItems
  | ChangePage
  | ChangePageSize
  | SetLoadingButton
  | ShowAlert

export const pickingValidateReducer = (
  state: PickingValidateState,
  action: Action
) => {
  switch (action.type) {
    case SET_SKU_ID:
      return {
        ...state,
        skuId: action.payload
      }
    case SET_PICKING_ROUTE_ID:
      return {
        ...state,
        pickingRouteId: action.payload
      }
    case SET_MESSAGE_STATUS:
      return {
        ...state,
        mensaje: action.payload
      }
    case SET_MESSAGE_COLOR:
      return {
        ...state,
        tipoMensaje: action.payload
      }
    case SWITCH_SNACKBAR:
      return {
        ...state,
        switchSnackBar: action.payload
      }
    case SWITCH_MODAL:
      return {
        ...state,
        switchModal: action.payload
      }
    case SET_ROWS_PICKING_VALIDATE:
      return {
        ...state,
        rows: action.payload
      }
    case SHOW_MODAL_REPORT_DIFF:
      return {
        ...state,
        showModalReportDiff: action.payload
      }
    case SET_IS_LOADING_GRID:
      return {
        ...state,
        isLoadingGrid: action.payload
      }
    case SET_BTN_FILTER:
      return {
        ...state,
        btnFilter: action.payload
      }
    case SET_LOADING_PRINT:
      return {
        ...state,
        isLoadingPrint: action.payload
      }
    case SET_PICKING_VALIDATE_PDF:
      return {
        ...state,
        pickingValidatePDF: action.payload
      }
    case SET_TOTAL_ITEMS:
      return {
        ...state,
        totalItems: action.payload
      }
    case CHANGE_PAGE:
      return {
        ...state,
        page: action.payload
      }
    case CHANGE_PAGE_SIZE:
      return {
        ...state,
        rowsPerPage: action.payload
      }
    case SET_LOADING_BUTTON:
      return {
        ...state,
        isLoadingButton: action.payload
      }
    case SHOW_ALERT:
      return {
        ...state,
        showAlert: action.payload
      }
    default:
      return state
  }
}
